import { render, staticRenderFns } from "./view-request.vue?vue&type=template&id=7ae0f19d&"
import script from "./view-request.vue?vue&type=script&lang=js&"
export * from "./view-request.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports